import { takeEvery } from 'redux-saga/effects';
import {
  remoteStreamSecretDecrypted,
  signalingEncryptedNameShared,
  signalingEncryptionKeyShared,
  signalingPublicKeyShared,
  signalingWhiteboardKeyRequested,
  signalingWhiteboardKeyShared,
  userNameDecrypted,
} from 'features/e2ee/actions';
import { onEncryptionKeySharedSaga } from 'features/e2ee/sagas/onEncryptionKeySharedSaga';
import { onRemoteStreamSecretDecryptedSaga } from 'features/e2ee/sagas/onRemoteStreamSecretDecryptedSaga';
import { userLeft } from 'features/users/usersSlice';
import { generateRoomE2eeCode } from 'features/e2ee/sagas/generateRoomE2eeCode';
import { onUserNameDecryptedSaga } from 'features/e2ee/sagas/onUserNameDecryptedSaga';
import { onEncryptedNameSharedSaga } from 'features/e2ee/sagas/onEncryptedNameSharedSaga';
import { onPublicKeySharedSaga } from 'features/e2ee/sagas/onPublicKeySharedSaga';
import { signalingUserJoined } from 'features/users/actions';
import { onUserJoinedSaga } from 'features/e2ee/sagas/onUserJoinedSaga';
import { onWhiteboardKeySharedSaga } from 'features/e2ee/sagas/onWhiteboardKeySharedSaga';
import { onWhiteboardKeyRequestedSaga } from 'features/e2ee/sagas/onWhiteboardKeyRequestedSaga';
import { signalingWhiteboardOpened } from 'features/layout/features/content/actions';
import { requestWhiteboardKeySaga } from 'features/e2ee/sagas/requestWhiteboardKeySaga';

export default function* e2eeWatcher() {
  yield takeEvery(signalingEncryptionKeyShared, onEncryptionKeySharedSaga);
  yield takeEvery(signalingEncryptedNameShared, onEncryptedNameSharedSaga);

  yield takeEvery(signalingPublicKeyShared, onPublicKeySharedSaga);
  yield takeEvery(remoteStreamSecretDecrypted, onRemoteStreamSecretDecryptedSaga);

  yield takeEvery(signalingUserJoined, onUserJoinedSaga);
  yield takeEvery(userLeft, generateRoomE2eeCode);
  yield takeEvery(userNameDecrypted, onUserNameDecryptedSaga);

  yield takeEvery(signalingWhiteboardOpened, requestWhiteboardKeySaga);
  yield takeEvery(signalingWhiteboardKeyShared, onWhiteboardKeySharedSaga);
  yield takeEvery(signalingWhiteboardKeyRequested, onWhiteboardKeyRequestedSaga);
}
